import styled from 'styled-components';

export const SummaryCardsContainer = styled.div`
	margin: 32px auto 16px auto;
`;
